import { render, staticRenderFns } from "./FreeDeliveryDecoration.vue?vue&type=template&id=fd4ecb72&name=free-delivery-decoration&"
import script from "./FreeDeliveryDecoration.vue?vue&type=script&lang=js&"
export * from "./FreeDeliveryDecoration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports